<!-- static content data from lang: visitor -->
<template>
  <div>
    <base-header class="pb-6" v-loading="loading">
      <template v-if="errored">
        <div class="page-not">
          <Notfound />

        </div>
      </template>
      <template v-else>
      <div class="row align-items-center pb-4">
        <div class="col-lg-12 col-12">
          <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.headerTitle}}</h6>
          <nav aria-label="breadcrumb" class="d-inline-block ml-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
      </template>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
          <div class="col-md-12">
            <template v-for="(message) in alertMessages">
              <Alert :type = alertType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
            </template>
            <template v-for="(message) in successMessages">
              <Alert :type = successType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
            </template>
            <validation-observer v-slot="{handleSubmit}" ref="formValidator">
              <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-lg-6">
                        <base-input
                          :label="lang.label.companyName"
                          v-model="model.companyName"
                          autocomplete="off"
                          disabled
                        ></base-input>
                      </div>
                      <div class="col-lg-6">
                        <base-input :label="lang.label.siteName" v-model="model.siteName.Name" autocomplete="off" disabled></base-input>
                      </div>
                      <div class="col-md-6">
                        <base-input class="date-picker" labelClasses="form-control-label asterisk-mark" :label="lang.label.fromAccessDate" name="From Access Date"
                          :rules="{required: true}">
                          <flat-picker
                            :config="{disable: [fromDateDisable],disableMobile: 'true',time_24hr: true,enableTime: true,dateFormat: 'd-m-Y H:i',minDate: fromDateMin,maxDate: fromDateMax}"
                            class="form-control datepicker"
                            v-model="dates.fromDate"
                            :placeholder="lang.label.selectDate"
                          ></flat-picker>
                          <div class="flat-calenda-icon">
                            <span data-toggle>
                              <i class="fas fa-calendar-alt text-primary"></i>
                            </span>
                          </div>
                        </base-input>
                      </div>
                      <div class="col-md-6">
                        <base-input class="date-picker" labelClasses="form-control-label asterisk-mark" :label="lang.label.toAccessDate" name="To Access Date"
                           :rules="{required: true}">
                          <flat-picker
                            :config="{disable: [toDateDisable],disableMobile: 'true',time_24hr: true,enableTime: true,dateFormat: 'd-m-Y H:i',minDate: toDateMin,maxDate: toDateMax}"
                            class="form-control datepicker"
                            v-model="dates.toDate"
                            :placeholder="lang.label.selectDate"
                          ></flat-picker>
                          <div class="flat-calenda-icon">
                            <span data-toggle>
                              <i class="fas fa-calendar-alt text-primary"></i>
                            </span>
                          </div>
                        </base-input>
                      </div>
                      <div class="col-lg-2" v-if="type == 2 || type == 4">
                        <label>&nbsp;</label>
                        <base-input name="auto approve">
                          <div>
                            <b-form-group>
                              <b-form-checkbox-group
                                id="approve"
                                v-model="checked"
                                :options="approve"
                                name="roles"
                                aria-label="auto approve"
                              ></b-form-checkbox-group>
                            </b-form-group>
                          </div>
                        </base-input>
                      </div>
                      <div class="col-lg-4" v-if="checked.length">
                        <base-input name="temperature">
                          <div>
                            <base-input
                              :label="lang.label.temperature"
                              labelClasses="form-control-label asterisk-mark"
                              v-if="checked.length"
                              :rules="{required: true,regex: /^[1-9]\d*(\.\d+)?$/}"
                              id="temperature"
                              v-model="temperature"
                              autocomplete="off"
                              name="temperature"
                              aria-label="temperature"
                            ></base-input>
                          </div>
                        </base-input>
                      </div>
                      <div :class="type != 2 && type != 4 ? 'col-lg-6' : 'col-lg-4'" v-if="!autoApprove">
                        <base-input
                          :label="lang.label.departments"
                          name="departments"
                          labelClasses="form-control-label asterisk-mark"
                          v-model="model.departments"
                        >
                          <template v-slot="{ input, focus, blur }">
                            <el-select
                              v-model="model.departments"
                              autocomplete="off"
                              :placeholder="lang.label.selectUser"
                              filterable
                              @change="val => input({ target: { value: val } })"
                              @focus="focus"
                              @blur="blur"
                            >
                              <el-option
                                v-for="(option,index) in departments"
                                :key="index"
                                :label="option.name"
                                :value="option.id"
                              ></el-option>
                            </el-select>
                          </template>
                        </base-input>
                      </div>
                      <div :class="type != 2 && type != 4 ? 'col-lg-6' : 'col-lg-4'" v-if="!autoApprove">
                        <base-input
                          :label="lang.label.workType"
                          name="workType"
                          :rules="autoApprove ? '' : {required: true}"
                          labelClasses="form-control-label asterisk-mark"
                          v-model="model.workType"
                        >
                          <template v-slot="{ input, focus, blur }">
                            <el-select
                              v-model="model.workType"
                              autocomplete="off"
                              :placeholder="lang.label.selectUser"
                              filterable
                              @change="val => input({ target: { value: val } })"
                              @focus="focus"
                              @blur="blur"
                            >
                              <el-option
                                v-for="(option,index) in workType"
                                :key="index"
                                :label="option.name"
                                :value="option.id"
                              ></el-option>
                            </el-select>
                          </template>
                        </base-input>
                        <div class="document-mapping-container">
                          <div v-for="(doc, index) in getDocumentList" 
                               :key="index" 
                               class="document-card mb-3 p-3 border rounded shadow-sm">
                            <div class="row align-items-center">
                              <!-- Required Document Name -->
                              <div class="col-md-3">
                                <div class="required-doc-label">
                                  <i class="fas fa-file-alt text-primary mr-2"></i>
                                  <strong>{{doc.name}}</strong>
                                </div>
                              </div>

                              <!-- Document Selection Dropdown -->
                              <div class="col-md-4">
                                <el-select 
                                  v-model="selectedUserDocs[doc.id]" 
                                  placeholder="Select document"
                                  class="w-100"
                                  @change="handleDocumentSelection($event, doc.id)"
                                >
                                  <el-option
                                    v-for="userDoc in userDocuments"
                                    :key="userDoc.id"
                                    :label="userDoc.document_name || userDoc.document_type.name"
                                    :value="userDoc.id"
                                  >
                                    <div class="d-flex align-items-center">
                                      <i class="far fa-file-pdf text-danger mr-2"></i>
                                      {{ userDoc.document_name || userDoc.document_type.name }}
                                    </div>
                                  </el-option>
                                </el-select>
                              </div>

                              <!-- Preview Section -->
                              <div class="col-md-5">
                                <div v-if="selectedUserDocs[doc.id]" class="selected-doc-preview">
                                  <div class="d-flex align-items-center justify-content-between p-2 bg-light rounded">
                                    <!-- Document Info -->
                                    <div class="d-flex align-items-center">
                                      <i class="far fa-file-pdf text-danger mr-2"></i>
                                      <span class="selected-doc-name">
                                        {{ getSelectedDocName(selectedUserDocs[doc.id]) }}
                                      </span>
                                    </div>
                                    
                                    <!-- Action Buttons -->
                                    <div class="preview-actions">
                                      <button 
                                        @click="previewDocument($event,selectedUserDocs[doc.id])" 
                                        class="btn btn-sm btn-primary mr-2"
                                        title="Preview Document"
                                      >
                                        <i class="fas fa-eye"></i>
                                      </button>
                                      <button 
                                        @click="clearSelection(doc.id)" 
                                        class="btn btn-sm btn-danger"
                                        title="Clear Selection"
                                      >
                                        <i class="fas fa-times"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div v-else class="no-doc-selected text-muted">
                                  <i class="fas fa-info-circle mr-1"></i>
                                  No document selected
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                   
                      <!--<div :class="!checked.length ? 'col-lg-4' :'col-lg-6'">
                        <base-input
                          :label="lang.label.visitor"
                          name="Visitor"
                          :rules="{required: true}"
                          labelClasses="form-control-label asterisk-mark"
                        >
                          <el-select
                            v-model="model.visitorID"
                            autocomplete="off"
                            :placeholder="lang.label.selectUser"
                            filterable
                            :disabled="type == 4 && (visitorId != null)"
                          >
                            <el-option
                              v-for="(option,index) in visitorsList"
                              :key="index"
                              :label="option.Name"
                              :value="option.ID"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div> -->      
                      <div class="col-md-12">
                        <base-input :label="lang.label.visitorRemarks"  name="visitor remark">
                          <textarea class="form-control" v-model="remarks" autocomplete="off" rows="3"></textarea>
                        </base-input>
                      </div>
                      <div class="col-md-12" v-if="questions">
                        <h3>Questions</h3>
                        <div class="form-group question-list" v-for="(que, index) in questions" :key="index">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-control-label">
                                <badge type="default" class="que-count">{{index + 1}}</badge>
                                <span v-html="que.CompanyQuestionsName"></span>
                                <b-form-group>
                                  <b-form-radio-group
                                    :id="'radio' + index"
                                    v-model="selected[index]"
                                    :options="answer"
                                    ref="questions"
                                    :name="'radio-options' + index"
                                  ></b-form-radio-group>
                                </b-form-group>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <base-input
                          :label="lang.label.groups"
                          name="Groups"
                        >
                          <el-select
                            v-model="model.groupName"
                            autocomplete="off"
                            :placeholder="lang.label.selectGroup"
                            filterable
                          >
                            <el-option
                              v-for="(option,index) in groupsList"
                              :key="index"
                              :label="option.Name"
                              :value="option.ID"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                      <div class="col-12" v-if="model.groupName">
                        <el-table
                          :data="queriedData"
                          row-key="id"
                          ref="table"
                          header-row-class-name="thead-light"
                          @sort-change="sortChange"
                          @selection-change="selectionChange"
                          border
                        >
                          <el-table-column type="selection" prop="checked">
                            <template slot-scope="scope">
                              <el-checkbox v-model="scope.row.check"></el-checkbox>
                            </template>
                          </el-table-column>
                          <el-table-column min-width="250px" label="Member Name" sortable prop="Name">
                            <div class="d-flex" slot-scope="scope" v-html="scope.row.Name"></div>
                          </el-table-column>
                          <el-table-column min-width="200px" label="Relationship type" sortable prop="RelationshipType">
                            <div class="d-flex" slot-scope="scope" v-html="scope.row.RelationshipType"></div>
                          </el-table-column>
                          <el-table-column min-width="150px" label="Photograph" sortable prop="Photograph">
                            <div class="d-flex" slot-scope="scope">
                              <img height="70px" width="70px" :src="getPhoto(scope.row.Photograph)" alt="">
                            </div>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-right mb-3">
                  <base-button type="primary" native-type="submit">{{lang.label.buttons.save}}</base-button>
                </div>
              </form>
            </validation-observer>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option, Checkbox } from "element-ui";
import Vue from 'vue';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import moment from 'moment';
import {mapGetters} from "vuex";
import Notfound from "@/views/GeneralViews/NotFoundPage.vue";
import Alert from "@/components/BaseAlert.vue";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import state from "../../store/state";

export default {
  mixins: [clientPaginationMixin],
  components: {
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [Checkbox.name]: Checkbox,
    [TableColumn.name]: TableColumn,
    flatPicker,
    Alert,
    Notfound,
  },
  data() {
    return {
      tableData: [],
      selectedRows: [],
      multipleSelection: [],
      remarks: '',
      alertType: 'danger',
      successType: 'success',
      alertMessages: [],
      successMessages: [],
      allow24Hrs: false,
      startDateBeforeX: null,
      fromDateMax: '',
      fromDateMin: 'today',
      toDateMin: 'today',
      toDateMax: '',
      temperature: null,
      checked: [],
      autoApprove: false,
      approve: [
        {text: 'auto approve', value: 'auto approve', disabled: false},
      ],
      errored: false,
      questions: [],
      loading:false,
      lang: this.$lang.visitor,
      selected: [],
      data: '',
      model: {
        companyName: "",
        siteName: "",
        departments: "",
        visitorID:"",
        groupName:"",
        workType:"",
      },
      selects: {
        simple: "Select"
      },
      departments: [],
      workType: [],
      requiredDocuments: [],
      dates: {
          fromDate: new Date(),
          toDate: moment(new Date()).add(1,'days').format('DD-MM-YYYY HH:mm'),
      },
      answer: [
          { text: 'Yes', value: 1 },
          { text: 'No', value: 0 },
      ],
       ID :this.$route.params.id,
       visitorsList:[],
       groupsList: [],
       userDocuments: [],
       selectedUserDocs: {},
       documentMappings: [],
    };
  },
  mounted(){
    if(this.type == 2){
      this.$router.push({name: "visitorRequestApproval"})
    }
    if(this.type == 4 && (!this.visitorId || this.visitorId == null)){ 
         this.$router.push({name: "visitorManagement"});  
    }
    this.loading = true;
      let self = this;
      if(this.disqualified && this.disqualified.includes('Based')) {
          self.alertMessages.push(this.disqualified);
      }else{
          self.successMessages.push(this.disqualified);
      }
    this.getVisitorList();
    this.getGroupList(true);
    let id = this.ID ;
    // if(this.type == 4){
      this.$store.dispatch('viewDocumnetsOfUser',this.model.visitorID).then(response => {
        this.userDocuments = response.data;
        this.loading = false;
      });
    // }
    this.$store.dispatch('VisitorForm',id).then(response => {
       if (response.status == 200) {
         this.allow24Hrs = response.data.Allow24Hrs;
         this.autoApprove =  response.data.AutoApprove;
         this.startDateBeforeX = response.data.StartDateBeforeX;
           this.dates.fromDate = moment(moment.now()).format('DD-MM-YYYY HH:mm');
           if(this.allow24Hrs){
               let someHoursAfter = moment(this.dates.fromDate,"DD-MM-YYYY HH:mm").add(15, 'hours').toDate();
               this.dates.toDate = moment(someHoursAfter).format("DD-MM-YYYY HH:mm");
           }
         this.model.companyName = response.data.company;
         this.model.siteName = response.data.site;
         if(this.type == 4 && this.visitorId){
          this.model.visitorID = this.visitorId;
         }
         this.departments = response.data.site.departments;
         this.workType = response.data.site.work_types;
         this.requiredDocuments = response.data.site;
         this.questions = response.data.questions;
         if(this.questions){
           this.questions.forEach((object, index) => {
            this.selected.push(object.DefaultValueType);
           });
         }
        this.loading = false;
       }else{
           if(response.status == 404){
               this.errored = true;
           }else{
               if(typeof response.data.message != 'object'){
                   this.alertMessages.push(response.data.message);
               }else{
                   let array = new Array();
                   for (let key of Object.keys(response.data.message)) {
                       let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                       array.push(obj)
                   }
                   this.alertMessages.push(array.join(', '));
                   setTimeout(function () {
                       self.alertMessages = [];
                   },5000)
               }
           }
           this.loading = false;
       }
    }).catch(error => {
      this.loading = false;
    });
  },
  computed:{
       ...mapGetters({
              login: "login",
              type: "type",
              disqualified: "disqualified",
              visitorId: "visitorId",
       }),
      groupSelected() {
           return this.model.groupName;
      },
      visitorSelected(){
          return this.model.visitorID;
      },
      getDocumentList() {
      if (!this.model.workType) {
        return;
      }
      const workType = this.workType.find(
        (type) => type.id === this.model.workType
      );
      let docs = workType.required_documents

      return workType ? docs : [];
    },
  },
  watch: {
      groupSelected(val) {
          this.getGroupMembers(val);
          console.log(val);
      },
      visitorSelected(val) {
          this.getGroupList(false, val);
      },
      getDocumentList: {
        immediate: true,
        handler(newDocs) {
          if (newDocs) {
            newDocs.forEach(doc => {
              if (!this.selectedUserDocs[doc.id]) {
                this.$set(this.selectedUserDocs, doc.id, null);
              }
            });
          }
        }
      }
  },
  methods: {
    getUserDocuments() {
        let self = this;
        this.$store.dispatch('visitorFormsList')
            .then(response => {
                if(response.status == 200) {
                    console.log(response.data,'datas');
                  
                }else{
                    if(typeof response.data.message != 'object'){
                        this.alertMessages.push(response.data.message);
                        setTimeout(function () {
                            self.alertMessages = [];
                        },5000)
                    }else{
                        var array = new Array();
                        for (let key of Object.keys(response.data.message)) {
                            let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                            array.push(obj)
                        }
                        this.alertMessages.push(array.join(', '));
                        setTimeout(function () {
                            self.alertMessages = [];
                        },5000)
                    }
                    self.loading = false;
                }
            }).catch(error => {
            });
    },  
    getPhoto(url) {
          return state.mediaURL + url;
    },
    selectionChange(selectedRows) {
            if (selectedRows.length) {
                selectedRows.forEach((object, index) => {
                    Vue.set(this.tableData[index], 'check', true);
                })
            } else {
                let tempData = this.tableData.slice();
                tempData.forEach((object, index) => {
                    Vue.set(this.tableData[index], 'check', false);
                })
            }
    },
    getGroupMembers(id) {
        let self = this;
        if(!id) {
            return true;
        }
        this.loading = true;
        this.$store.dispatch('viewGroup', id)
            .then(response => {
                    if(response.status == 200) {
                        let tempArray = response.data.Members;
                        response.data.Members.forEach((object,index) => {
                            tempArray[index].check = true;
                        });
                        this.tableData = tempArray;
                    }else {
                        if(typeof response.data.message != 'object'){
                            this.alertMessages.push(response.data.message);
                            setTimeout(function () {
                                self.alertMessages = [];
                            },5000)
                        }else{
                            var array = new Array();
                            for (let key of Object.keys(response.data.message)) {
                                let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                array.push(obj)
                            }
                            this.alertMessages.push(array.join(', '))
                        }
                        window.scrollTo(0,0);
                        setTimeout(function () {
                            self.alertMessages = [];
                        },3000)
                    }
                  this.loading = false;
            })
    },
    getGroupList(firstTime = false, visitorID= ''){
        let self = this;
        if(!firstTime) {
            this.loading = true;
        }
        let id = !this.login.IsVisitor ? this.visitorId : this.login.ID;
        if(!this.model.visitorID && id ) {
            this.model.visitorID = id;
        }
        if(visitorID){
            id = visitorID;
        }
        if(!id) {
            this.loading = false;
            return true;
        }
            this.$store.dispatch('visitorGroupList', {ID: id})
            .then(response => {
                if(response.status == 200) {
                    this.groupsList = response.data;
                    console.log(this.groupsList)
                }else {
                    if(typeof response.data.message != 'object'){
                        this.alertMessages.push(response.data.message);
                        setTimeout(function () {
                            self.alertMessages = [];
                        },5000)
                    }else{
                        var array = new Array();
                        for (let key of Object.keys(response.data.message)) {
                            let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                            array.push(obj)
                        }
                        this.alertMessages.push(array.join(', '))
                    }
                    window.scrollTo(0,0);
                    setTimeout(function () {
                        self.alertMessages = [];
                    },3000)
                }
                if(!firstTime) {
                    this.loading = false;
                }
            }).catch(reason => {
                if(!firstTime) {
                    this.loading = false;
                }
        })
    },
    fromDateDisable(date){
        // let someHoursBefore;
        if(this.dates.toDate){
            // someHoursBefore = moment(moment(this.dates.toDate,'DD-MM-YYYY HH:mm').toDate(),"DD-MM-YYYY").subtract(15,'hours').toDate();
            if(this.allow24Hrs || this.startDateBeforeX){
                let minimumTime = moment(moment.now()).format('DD-MM-YYYY HH:mm');
                this.fromDateMin = minimumTime;
                this.fromDateMax = this.startDateBeforeX ? moment(moment.now()).add(this.startDateBeforeX,'hours').format('DD-MM-YYYY HH:mm'):
                                   this.toDateMin
            }else{
                this.fromDateMin = moment(moment.now()).format('DD-MM-YYYY HH:mm');
            }
        }else{
            this.fromDateMax = false;
        }
        return false;
    },
    toDateDisable(date){
        if(this.dates.fromDate){
            let someHoursAfter = moment(this.dates.fromDate,"DD-MM-YYYY HH:mm").add(15, 'hours').toDate();
            if(this.allow24Hrs || this.startDateBeforeX){
                // this.toDateMin = this.dates.fromDate;
                this.toDateMax = this.allow24Hrs ? moment(someHoursAfter).format("DD-MM-YYYY HH:mm") : '';
            }
            this.toDateMin = this.dates.fromDate;
        }else{
            this.toDateMin = moment(moment.now()).format('DD-MM-YYYY HH:mm');
        }
        return false;
    },
    onSubmit() {
        let IDs = [];
        this.tableData.forEach((object, index) => {
            if(object.check) {
                IDs.push(object.ID);
            }
        });
      let self = this;

      // this.model.groupName
      this.loading= true;
        let answers = [];
        if(this.$refs.questions){
            this.$refs.questions.forEach((object,index) => {
                answers.push({id:index,checked: object.localChecked });
            });
        }
        let answerArray = [];
        if(this.questions){
            this.questions.forEach((object,index) => {
                if(answers[index].checked != "none"){
                    answerArray.push({
                        "CompanyQuestionnaireQuestionsID": object.CompanyQuestionnaireQuestionsID,
                        "QuestionAnswerBoolean": answers[index].checked
                    })
                }
            });
        }
       
        let data = {
            CompanySiteQuestionnairesID: this.ID,
            AccessRequestDateFrom: moment(this.dates.fromDate,"DD-MM-YYYY HH:mm").format('YYYY-MM-DD HH:mm'),
            AccessRequestDateTo: moment(this.dates.toDate,"DD-MM-YYYY HH:mm").format('YYYY-MM-DD HH:mm'),
            SystemUserID_Host: null,
            department: this.model.departments,
            VisitorRemarks: this.remarks,
            work_type: this.model.workType,
            VisitorID:(this.login.IsVisitor == false ? this.model.visitorID :this.login.ID) ,
            documents: this.documentMappings.map(mapping => mapping.user_document_id)
        };
        if(answerArray){
            data.Answers = answerArray;
        }
        if(this.type == 2 || this.type == 4 || this.type == 3){
            data.BodyTemperature = this.temperature;
        }

        data.Member = IDs.join(',');
      //  groupManagement
      this.$store.dispatch('visitorQuestionForm',data).then(response=> {
          if(response.status == 200){
              this.$store.commit('setDisqualified',response.data.message);
              let routeName = '';
              if(this.type == 2 || this.type == 4){
                  if(this.type == 4 && this.checked.length){
                      routeName = "visitorManagement";
                  }else{
                      routeName = "visitorRequestApproval";
                  }
              }else{
                  if(this.login.IsVisitor == false){
                      routeName = "report";
                  } else {
                      // routeName = "visitorEditProfile";
                      routeName = "Login";
                  }
                  if(this.login.IsRegistrar) {
                      routeName = "visitorManagement";
                  }
              }
              console.log("routeName", routeName);
              this.$router.push({ name: routeName });
          }else{
              if(typeof response.data.message != 'object'){
                  this.alertMessages.push(response.data.message);
                  setTimeout(function () {
                      self.alertMessages = [];
                  },5000)
              }else{
                  var array = new Array();
                  for (let key of Object.keys(response.data.message)) {
                      let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                      array.push(obj)
                  }
                  this.alertMessages.push(array.join(', '))
              }
              window.scrollTo(0,0);
              setTimeout(function () {
                  self.alertMessages = [];
              },3000)
          }
        this.loading=false;
      });
    },
    getVisitorList(){
        let self = this;
      this.$store.dispatch('visitorsList').then(response=> {
        this.visitorsList = response;
          if(this.disqualified){
              setTimeout(function () {
                  self.alertMessages = [];
                  self.successMessages = [];
                  self.$store.commit('setDisqualified', '');
              },3000)
          }
        // this.loading=false;
      });
    },
    handleDocumentSelection(userDocId, requiredDocId) {
        const existingIndex = this.documentMappings.findIndex(
            mapping => mapping.required_document_id === requiredDocId
        );

        if (existingIndex !== -1) {
            if (userDocId) {
                this.documentMappings[existingIndex].user_document_id = userDocId;
            } else {
                this.documentMappings.splice(existingIndex, 1);
            }
        } else if (userDocId) {
            this.documentMappings.push({
                required_document_id: requiredDocId,
                user_document_id: userDocId
            });
        }
    },
    getSelectedDocName(docId) {
      const doc = this.userDocuments.find(d => d.id === docId);
      return doc ? doc.document_name || doc.document_type.name : '';
    },
    previewDocument(e,docId) {
      e.preventDefault();
      const doc = this.userDocuments.find(d => d.id === docId);
      if (doc && doc.document) {
        window.open(state.mediaURL+doc.document, '_blank');
      }
    },
    clearSelection(docId) {
      this.$set(this.selectedUserDocs, docId, null);
      // Remove from mappings if exists
      const existingIndex = this.documentMappings.findIndex(
        mapping => mapping.required_document_id === docId
      );
      if (existingIndex !== -1) {
        this.documentMappings.splice(existingIndex, 1);
      }
    },
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
.modal-header {
  padding-bottom: 0;
}
.document-mapping-container {
  max-width: 100%;
  margin: 20px 0;
}

.document-card {
  background: #fff;
  transition: all 0.3s ease;
}

.document-card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.15) !important;
}

.required-doc-label {
  font-size: 0.95rem;
  color: #344767;
}

.selected-doc-preview {
  transition: all 0.3s ease;
}

.selected-doc-name {
  font-size: 0.9rem;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.preview-actions button {
  padding: 0.25rem 0.5rem;
}

.preview-actions button i {
  font-size: 0.875rem;
}

.no-doc-selected {
  font-size: 0.9rem;
  padding: 0.5rem;
}

/* Animation for selection changes */
.selected-doc-preview {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
